// Phase 3 — first downgraded Angular service, using the modern HttpClient stack. Replaces
// the AngularJS `AdminLayoutService` factory (deleted); exposed back to AngularJS via
// downgradeInjectable (see downgrades.ts). The single consumer (AdminLayoutController) calls
// `.counts().then(...)`, so counts() returns a Promise.
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminLayoutService {
    private http = inject(HttpClient);

    counts(): Promise<any> {
        // HttpClient.get() resolves to the parsed body — same as the old `resp.data`.
        return firstValueFrom(this.http.get('/admin/counts'));
    }
}
